import { render, staticRenderFns } from "./PasswordView.vue?vue&type=template&id=546512d8&scoped=true"
import script from "./PasswordView.vue?vue&type=script&lang=js"
export * from "./PasswordView.vue?vue&type=script&lang=js"
import style0 from "./PasswordView.vue?vue&type=style&index=0&id=546512d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546512d8",
  null
  
)

export default component.exports